import type { TFunction } from 'i18next'
import type { ConfigurationOptionalEquipment } from '#app/store/slices/configurationSlice'
import type { ComparisonDataEntry } from '../Comparison/useLinearizeComparisonData'

export const estimateChangeTableSize = (entry: ComparisonDataEntry) => {
  switch (entry.type) {
    case 'group': {
      const anyGroup = entry.base ?? entry.comparison
      if (!anyGroup?.parentGroup) {
        return 50
      }
      return 41
    }
    case 'family':
      return 34
  }
}

export const equipmentName = (equipment: ConfigurationOptionalEquipment, t: TFunction) => {
  if (equipment.title && equipment.title.length > 0) {
    return equipment.title
  }
  if (equipment.variants.length <= 0) {
    return t('configuration.optional-equipment.default-title')
  }
  const leadingVariant = equipment.variants[0]
  const title = `${leadingVariant.family.title}: ${leadingVariant.targetVariant.title}`
  const extraVariants = equipment.variants.length - 1
  return extraVariants <= 0
    ? title
    : t('configuration.optional-equipment.default-title-with-variant', '{{leadingTitle}} (+ {{count}} variants)', {
        leadingTitle: title,
        count: extraVariants,
      })
}
